// modules
import { Modal } from "antd";

// components
import { default as DialogComponent } from "components/molecules/Dialog/Dialog";
import ConfirmDialog from "components/molecules/Dialog/ConfirmDialog";
import getIcon from "utils/getIcon";
import theme from "styles/theme";

type DialogProps = {
	closable?: boolean;
	title?: string;
	subtitle?: string;
	type?: string;
	description?: string;
	actionButton?: {
		label: string;
		onClick?: () => void;
	};
	confirmButton?: {
		label: string;
		onClick?: () => void;
	};
	cancelButton?: {
		label: string;
		onClick?: () => void;
		classes?: {
			label?: string;
			buttonInput?: string;
		};
	};
	okButton?: {
		label: string;
		onClick: () => void;
	};
	linkButton?: {
		label: string;
		onClick?: () => void;
	};
	onCloseIconClick?: () => void;
};

const ModalContainer = ({ closable, type, title, subtitle, description, actionButton, confirmButton, cancelButton, linkButton, okButton, onCloseIconClick }: DialogProps) => {
	const modal = Modal.success({});

	const Component =
		type === "confirm" ? (
			<ConfirmDialog
				title={title}
				description={description}
				subtitle={subtitle}
				destroy={modal.destroy}
				linkButton={linkButton}
				cancelButton={cancelButton}
				actionButton={actionButton}
				confirmButton={confirmButton}
			/>
		) : (
			<DialogComponent title={title} subtitle={subtitle} destroy={modal.destroy} okButton={okButton} />
		);

	modal.update({
		content: Component,
		centered: true,
		icon: null,
		closable: closable,
		okButtonProps: { hidden: true },
		width: "28.125rem",
		bodyStyle: { padding: "0", margin: 0 },
		className: "cag_modal",
		closeIcon: (
			<span className="pt-4 h-full flex items-center" onClick={onCloseIconClick}>
				{getIcon({ icon: "cancel", width: "1.5rem", height: "1.5rem", iconColor: theme.colors.violet })}
			</span>
		),
		onCancel: () => {
			modal.destroy();
			if (okButton?.onClick) {
				okButton?.onClick();
			}
		}
	});

	return null;
};

export default ModalContainer;
